import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '@mulesoft/anypoint-components/lib/Button';
import Icon from '@mulesoft/anypoint-icons/lib/Icon';
import DeprecateIcon from '@mulesoft/anypoint-icons/lib/svg/warning-small.svg';
import RevertDeprecateAssetModal from '~/components/AssetDetail/Actions/RevertDeprecateAssetModal';
import { isAPIGroup } from '~/utils/types';
import styles from './DeprecationHeader.css';

const buttonStyles = Button.themes.DefaultTheme;

const DeprecationHeader = ({
  isAdmin,
  asset,
  openModal,
  isConsistentNavigationEnabled,
  isMinorDeprecated
}) => {
  const isAPIGroupAsset = isAPIGroup(asset);
  const isFullVersionDeprecation =
    !isConsistentNavigationEnabled || isAPIGroupAsset;
  const deprecationText = `This ${
    isFullVersionDeprecation ? '' : 'minor '
  }version has been deprecated`;

  return (
    <div
      className={styles.deprecationHeader}
      display-if={!isConsistentNavigationEnabled || isMinorDeprecated}
      data-test-id="deprecation-header"
      role="status"
    >
      <Icon title="Deprecated Version" size="s">
        <DeprecateIcon />
      </Icon>
      <span
        data-test-id="deprecation-label"
        className={styles.text}
        title={deprecationText}
      >
        {deprecationText}
      </span>
      <span className={styles.actions}>
        <Button
          testId="revert-deprecation-action"
          kind="tertiary"
          display-if={isAdmin && !isConsistentNavigationEnabled}
          className={classNames(
            buttonStyles.button,
            buttonStyles.noFill,
            buttonStyles.tertiary,
            styles.action
          )}
          onClick={() => openModal(RevertDeprecateAssetModal, { asset })}
        >
          Revert
        </Button>
      </span>
    </div>
  );
};

DeprecationHeader.propTypes = {
  isAdmin: PropTypes.bool,
  openModal: PropTypes.func,
  asset: PropTypes.object,
  isConsistentNavigationEnabled: PropTypes.bool,
  isMinorDeprecated: PropTypes.bool
};

export default DeprecationHeader;
